// extracted by mini-css-extract-plugin
export var container = "_dd-0";
export var icon = "_dd-1";
export var text = "_dd-2";